/**
 * Marca una conversación como leída/revisada por el operador.
 *
 * Se dispara al abrir el thread (ver ConversationPage). Persiste
 * last_read_at=now en el backend y refresca la lista para que el indicador
 * de "no leído" se apague. Fire-and-forget: si falla, no rompe la vista.
 */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiPost } from "@/lib/api";

export function useMarkConversationRead() {
  const qc = useQueryClient();
  return useMutation<{ ok: boolean }, Error, { conversationId: string }>({
    mutationFn: ({ conversationId }) =>
      apiPost<{ ok: boolean }>(`/conversations/${conversationId}/mark-read`),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["conversations"] });
    },
  });
}
